import type { SequenceData, SequenceNumber, ValidRingSequence } from '@app/models/optimus-configuration.ts'

export const validateRingSequence = (ring_sequence: (string | number | SequenceNumber)[]) => {
	const are_numbers_valid = ring_sequence.every((seq) => {
		if (Number.isFinite(seq)) {
			const seq_number = seq as number
			if (seq_number >= 1 && seq_number <= 8) {
				return true
			}
		}
		return false
	})

	if (!are_numbers_valid) {
		console.error('Sequence is not valid: ', ring_sequence)
		return null
	}

	return ring_sequence as ValidRingSequence
}

interface IValidateSequence {
	sequence: SequenceData
	currentErrors: Record<string, string>
}
export const validateSequence = ({ sequence, currentErrors }: IValidateSequence) => {
	const sequence_rings = sequence.sequence_data.phaseSequence

	const phase_count: Record<number, number> = {}
	Object.values(sequence_rings)
		.flat()
		.forEach((phase) => {
			if (phase in phase_count) {
				const error_key = `${sequence.sequence_external_id}-1-duplicate-phase-${phase}`
				currentErrors[error_key] = `Plan #${sequence.sequence_external_id}: Duplicate Phase - ${phase}`
			} else {
				phase_count[phase] = 1
			}
		})
}
